import { ProductlistPageModel } from 'models/ProductlistPageModel';
import filterReducer from 'components/Filter/reducer';
import { GOTO_PAGE, GotoPageAction, SET_SORT_ORDER, SortOrderAction } from './actions';
import {
  PRODUCTLIST_PRODUCTS_UPDATE,
  ProductlistFilterAction
} from 'views/ProductlistPage/actions';
import { createReducer } from 'store/createReducer';
import initialPageState from 'components/Pagelayout/initialPageState';

export default createReducer(initialPageState, {
  [GOTO_PAGE]: (state: ProductlistPageModel, action: GotoPageAction) => {
    return {
      ...state,
      pageNbr: action.pageNumber,
      products: action.products
    };
  },
  [SET_SORT_ORDER]: (state: ProductlistPageModel, action: SortOrderAction) => {
    return {
      ...state,
      selectedSortOrder: action.sortOrder
    };
  },
  [PRODUCTLIST_PRODUCTS_UPDATE]: (
    state: ProductlistPageModel,
    { type, ...action }: ProductlistFilterAction
  ) => {
    return {
      ...state,
      ...action
    };
  },
  ...filterReducer
});
